import { render, staticRenderFns } from "./ProfileStep.vue?vue&type=template&id=7ddd107e&"
import script from "./ProfileStep.vue?vue&type=script&lang=ts&"
export * from "./ProfileStep.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileStep.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports